import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import {patientService} from "api";
import {AppThunk} from "redux/store";

export interface State {
  data: any;
  loading: string;
  error: null;
}

const initialState: State = {
  data: [],
  loading: "idle",
  error: null,
};

export const getPatients = createAsyncThunk("patient/getPatients", async () => {
  const response = await patientService.getPatients();
  return response.data;
});

export const accountSlice = createSlice({
  name: "patient",
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      // xu ly action dang nhap
    },
  },
  extraReducers(builder) {
    builder.addCase(getPatients.pending, (state, action) => {
      if (state.loading === "idle") {
        state.loading = "pending";
      }
    });
    builder.addCase(getPatients.fulfilled, (state, action) => {
      if (state.loading === "pending") {
        state.data = action.payload;
        state.loading = "idle";
      }
    });
  },
});

export const {login} = accountSlice.actions;
export default accountSlice.reducer;
